export default __webpack_public_path__ + "static/media/Freebooter's Armbands of the Untamed.920698f4.jpg";